'use client';

import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { detectRegion, getConsent, saveConsent } from '@/lib/consent';
import ConsentPreferenceCenter from './ConsentPreferenceCenter';

type ConsentRegion = 'gdpr' | 'ccpa' | 'none';

export default function CookieBanner() {
  const [region, setRegion] = useState<ConsentRegion>('none');
  const [hasConsent, setHasConsent] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);

  useEffect(() => {
    const detectedRegion = detectRegion();
    setRegion(detectedRegion);

    const existingConsent = getConsent();
    if (existingConsent) {
      setHasConsent(true);
    }
  }, []);

  const handleAcceptAll = () => {
    saveConsent(
      {
        analytics: true,
        marketing: true,
        preferences: true,
      },
      region
    );
    setHasConsent(true);
  };

  const handleRejectAll = () => {
    saveConsent(
      {
        analytics: false,
        marketing: false,
        preferences: false,
      },
      region
    );
    setHasConsent(true);
  };

  if (region === 'none' || hasConsent) {
    return null;
  }

  if (region === 'gdpr') {
    return (
      <>
        <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t shadow-lg" style={{ borderColor: 'var(--border)', backgroundColor: 'var(--background)' }}>
          <div className="max-w-7xl mx-auto px-6 md:px-10 py-6">
            <div className="flex flex-col gap-4">
              <div>
                <h3 className="font-semibold mb-2" style={{ color: 'var(--foreground)' }}>
                  Wir respektieren Ihre Privatsphäre
                </h3>
                <p className="text-sm mb-3" style={{ color: 'var(--muted-foreground)' }}>
                  Wir verwenden Cookies und ähnliche Technologien, um Ihre Erfahrung zu verbessern. Bitte lesen Sie unsere{' '}
                  <Link href="/privacy" className="underline" style={{ color: 'var(--accent)' }}>
                    Datenschutzerklärung
                  </Link>
                  {' '}und{' '}
                  <Link href="/cookies" className="underline" style={{ color: 'var(--accent)' }}>
                    Cookie-Richtlinie
                  </Link>
                  .
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={handleAcceptAll}
                  className="px-4 py-2 rounded font-medium text-sm transition-colors"
                  style={{
                    backgroundColor: 'var(--accent)',
                    color: 'white',
                  }}
                >
                  Alle akzeptieren
                </button>
                <button
                  onClick={handleRejectAll}
                  className="px-4 py-2 rounded font-medium text-sm transition-colors border"
                  style={{
                    borderColor: 'var(--border)',
                    color: 'var(--foreground)',
                  }}
                >
                  Alle ablehnen
                </button>
                <button
                  onClick={() => setShowPreferences(true)}
                  className="px-4 py-2 rounded font-medium text-sm transition-colors border"
                  style={{
                    borderColor: 'var(--border)',
                    color: 'var(--foreground)',
                  }}
                >
                  Einstellungen verwalten
                </button>
              </div>
            </div>
          </div>
        </div>
        {showPreferences && (
          <ConsentPreferenceCenter
            onClose={() => setShowPreferences(false)}
            onSave={() => {
              setHasConsent(true);
              setShowPreferences(false);
            }}
          />
        )}
      </>
    );
  }

  return null;
}
